import React from "react";
import vrCircle from "../../assets/images/svg/vr_circle.svg";
import {
  EducationIcon,
  MotionIcon,
  PlugIcon,
  PostIcon,
  RealTimeIcon,
  ServicesIcon,
  XRIcon,
} from "../common/Icons";

const VrServices = () => {
  return (
    <div className="py-3 py-md-4 py-lg-5" style={{ backgroundColor: "transparent" }}>
      <div className="container pb_b">
        <h2 className="fs_44 fw-bold text-center mb-0 ff_s" style={{ color: "#f8fafc" }}>
          Our AR/VR Services
        </h2>
        <p className="fs_16 mb-md-0 text-center col-lg-10 pt-3 col-xl-6 mx-auto" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
          Powered by in-house talent trained across AVGC-XR disciplines, we
          don’t just deliver content—we deliver{" "}
          <strong>creative power&nbsp;</strong> at scale.
        </p>
        <div className="d-flex pt_73 pt-4 pt-md-0 flex-column justify-content-center align-items-center position-relative">
          <img
            loading="lazy"
            decoding="async"
            className="position-absolute d-none vr_circle d-md-block top-0 start-50 translate-middle-x w-100"
            src={vrCircle}
            alt="vr clicle"
          />
          {/* First Box */}
          <div className="row gap_78 pt_50 justify-content-center">
            <div className="col-md-3 d-flex flex-column align-items-center col-6 mt_78">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <PostIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Post-production, VFX layering and asset optimization
                </p>
              </div>
            </div>
            {/* Second Box */}
            <div className="col-md-3 d-flex flex-column align-items-center col-6">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <EducationIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Studio & on-location AR/VR shoots
                </p>
              </div>
            </div>
            {/* Three Box */}
            <div className="col-md-3 d-flex flex-column align-items-center col-6 mt_70 mt_78">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <RealTimeIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Real-time rendering and spatial audio design
                </p>
              </div>
            </div>
            {/* Four Box */}
            <div className="col-md-3 d-flex flex-column align-items-center d-md-none mt_70 col-6 mt_78">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <XRIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  XR content pipelines optimized for headset, mobile, and
                  browser
                </p>
              </div>
            </div>
            {/* Five Box */}
            <div className="col-md-3 d-flex flex-column align-items-center d-md-none mt_70 col-6">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <PlugIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Plug-and-play AR filters AR ads and interactive campaigns
                </p>
              </div>
            </div>
            {/* Six Box */}
            <div className="col-md-3 d-flex flex-column align-items-center d-md-none mt_70 col-6 mt_78">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <MotionIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Motion capture integration & rigging for avatars
                </p>
              </div>
            </div>
            {/* seven Box */}
            <div className="col-md-3 d-flex flex-column align-items-center d-md-none mt_70 col-6 mt_78">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <ServicesIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Immersive environment creation for apps and web
                </p>
              </div>
            </div>
          </div>

          <div className="row gap_78 pt_55 d-none d-md-flex justify-content-center">
            <div className="col-3 mt_82">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <XRIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  XR content pipelines optimized for headset, mobile and browser
                </p>
              </div>
            </div>
            <div className="col-3">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <PlugIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Plug-and-play AR filters AR ads and interactive campaigns
                </p>
              </div>
            </div>
            <div className="col-3 mt_82">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <MotionIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Motion capture integration & rigging for avatars
                </p>
              </div>
            </div>
          </div>
          <div className="row gap_78 pt_50 d-none d-md-flex ">
            <div className="col-3 ms-md-3">
              <div className="vr_box bg_theme position-relative">
                <span className="icon_set position-absolute">
                  {" "}
                  <ServicesIcon />
                </span>
                <p className="max_w_132 w-100 fs_14 fw-bold text-white mx-auto text-center lh_110">
                  Immersive environment creation for apps and web
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VrServices;
